import React, { Component } from 'react';
import { trackEvent } from 'react-with-analytics';
import ReCAPTCHA from 'react-google-recaptcha';

import '../css/components/Formulaire.css';

import ZigZag from './ZigZag';

const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
}

class FormulaireDeContact extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.show = props.show;

        this.onCancel = props.onCancel;

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        var newState = this.state;
        newState[event.target.name] = event.target.value;
        this.setState(newState);
    }

    handleRecaptcha = value => {
        var newState = this.state;
        newState['g-recaptcha-response'] = value;
        this.setState(newState);
    };

    handleSubmit(event) {
        event.preventDefault();

        trackEvent('Interactions', 'Envoi de formulaire', 'Formulaire de contact');

        this.netlifySubmit();
    }

    netlifySubmit() {
        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({ "form-name": "contact", ...this.state })
        })
        .then((data) => {
            this.onCancel();
        })
        .catch(error => console.log(error));
    }

    componentWillReceiveProps(newProps){
        this.show = newProps.show;
        this.forceUpdate();
    }

  render() {
        return (
            this.show ? (
                <div className="form-container">
                    <div className="form-overlay" onClick={this.onCancel} />
                    <div className="form">
                        <div onClick={this.onCancel} className="form-close">&#215;</div>
                        <div className="form-content">
                            <section className="form-header bloc-texte">
                                <ZigZag />
                                <h2>Contactez-nous !</h2>
                                <ZigZag />
                            </section>
                            <form onSubmit={this.handleSubmit} netlify netlify-recaptcha netlify-honeypot="bot-field">
                                <div className="recaptcha">
                                    <ReCAPTCHA ref="recaptcha" sitekey={RECAPTCHA_KEY} onChange={this.handleRecaptcha} />
                                </div>

                                <h3>Vous :</h3>
                                <div className="input-group">
                                    <input type="text" name="firstname" onChange={this.handleChange} placeholder="Prénom" required />
                                    <input type="text" name="lastname" onChange={this.handleChange} placeholder="Nom" required />
                                </div>
                                <div className="input-group">
                                    <input type="text" name="company" onChange={this.handleChange} placeholder="Société" />
                                </div>
                                <div className="input-group">
                                    <input type="phone" name="phone" onChange={this.handleChange} placeholder="Téléphone" />
                                    <input type="email" name="email" onChange={this.handleChange} placeholder="E-mail" required />
                                </div>
                                <h3>Message :</h3>
                                <textarea name="message" onChange={this.handleChange}></textarea>

                                <p>En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de la relation commerciale qui peut en découler.</p>
                                <button type="submit" className="btn btn-black">Envoyer</button>
                            </form>
                        </div>
                    </div>
                </div>
            ) : null
        );
  }
}

export default FormulaireDeContact;



// WEBPACK FOOTER //
// ./src/components/FormulaireDeContact.js